export default {
    messages: [],

    debugMode: 0,

    /**
     * Logs a message with type info
     * @param {String} _msg The message to log
     */
    info: function (_msg) {
        return this.log(_msg, 'info');
    },

    /**
     * Logs a message with type warn
     * @param {String} _msg The message to log
     */
    warn: function (_msg) {
        return this.log(_msg, 'warn');
    },

    /**
     * Logs a message with type info
     * @param {String} _msg The message to log
     */
    error: function (_msg) {
        return this.log(_msg, 'error');
    },

    /**
     * Logs a message with own type
     * @param {String} _msg The message to log
     * @param {String|null} _type The log type ('error', 'warn', 'info' (default))
     * @return {Object} An object which can be used as throw object
     */
    log: function (_msg, _type) {
        const msg = _msg || null,
            type = _type || 'info';

        if (!msg) return false;

        this.messages.push({ content: _msg, type: type });

        return {
            name: 'JavaScript Error',
            message: msg,
        };
    },

    /**
     * Prints log messages to console
     * @param {String} filter Only prints messages of type filter
     */
    show: function (filter) {
        let messages = this.messages,
            i = 0,
            len = messages.length;

        if (len === 0) {
            console.info('No log messages to show');
            return false;
        }

        for (i; i < len; i++) {
            const msg = messages[i],
                content = msg.content,
                type = msg.type;

            // Only show by filter type
            if (filter) {
                if (filter === type) {
                    console[filter](content);
                }
            } else {
                console[type](content);
            }
        }
    },

    reset: function () {
        this.messages = [];
    },
};
